export enum IdType {
  MyKad = 1,
  Passport = 2,
  Army = 4,
  Police = 5
}
